module.exports = __webpack_public_path__ + "img/08.07e13fb5.jpg";